export enum ROUTING_KEY {
  PLACE_LIST = 'PLACE_LIST',
  PLACE = 'PLACE',
  EVENT_LIST = 'EVENT_LIST',
  EVENT = 'EVENT',
  GUIDE_LIST = 'GUIDE_LIST',
  GUIDE = 'GUIDE',
  DEAL_LIST = 'DEAL_LIST',
  DEAL = 'DEAL',
  YOUR_PLANS = 'YOUR_PLANS',
  TICKET_LIST = 'TICKET_LIST',
  YOUR_PASSPORT_LIST = 'YOUR_PASSPORT_LIST',
  FAKE = 'FAKE',
  CATEGORY = 'CATEGORY',
  STATIC_PAGE = 'STATIC_PAGE',
  STANDALONE_EVENT = 'STANDALONE_EVENT',
  STANDALONE_PASSPORT = 'STANDALONE_PASSPORT',
  PASSPORT_LIST = 'PASSPORT_LIST',
  PASSPORT = 'PASSPORT',
  STANDALONE_PASSPORT_CHECK_IN = 'STANDALONE_PASSPORT_CHECK_IN',
  RESUBSCRIBE_REMINDER = 'RESUBSCRIBE_REMINDER',
  UNSUBSCRIBE_REMINDER = 'UNSUBSCRIBE_REMINDER',
}
